import { Timestamp } from 'rxjs/internal/operators/timestamp'
import { People } from './peopleClass'

export class PtMeeting {
  eventId: string
  role: string
  restricted: boolean
  restrictedInviteOnly: boolean
  eventTitle: string
  description: string
  start: number
  end: number
  timezone: string
  tzShortName: string
  sharingUrl: string
  joinUrl: string
  pstnEnabled: boolean
  loggerServiceUrl: string
  authenticationType: string
  enterpriseId: number
  eventSocketUrl: string
  systemCapacity:null
  instanceId:null
  billingCapacity:null
  requireEmail: boolean
  enableRegistration: boolean
  recurrenceStart:null
  baseApiUrl: string
  whitelistedDomains: string
  allowInvitedAttendeesOnly: boolean
  recurrencePattern: any
}

export enum MeetingVideoState {
  /**
   * Video is in active state
   */
  ACTIVE = "ACTIVE",
  /**
   * Video is inactive since only one participant is present in meeting
   */
  INACTIVE_ONLY_PARTICIPANT = "INACTIVE_ONLY_PARTICIPANT",
  /**
   * Video is inactive since no one has shared any video
   */
  INACTIVE_NO_ONE_HAS_VIDEO = "INACTIVE_NO_ONE_HAS_VIDEO",
  /**
   * Video is inactive since there are no moderator present in meeting
   */
  INACTIVE_NEEDS_MODERATOR = "INACTIVE_NEEDS_MODERATOR",
  /**
   * Video is inactive since meeting is disconnected
   */
  INACTIVE_DISCONNECTED = "INACTIVE_DISCONNECTED",
}



export enum MeetingConnectionState {
  /**
   * Meeting connection is in idle state
   */
  IDLE = "IDLE",
  /**
   * Meeting is trying to connect
   */
  CONNECTING = "CONNECTING",
  /**
   * Meeting is in connected state
   */
  CONNECTED = "CONNECTED",
  /**
   * Meeting is in disconnected state
   */
  DISCONNECTED = "DISCONNECTED",
  /**
   * Meeting is trying to reconnect
   */
  RECONNECTING = "RECONNECTING",
  WAITING = "WAITING"
}

export interface MeetingParticipant {

  /**
   * Name of the participant
   */
  name: string

  /**
   * Is this the own participant info or the others.
   */
  isSelf: boolean

  /**
   * Is this participant a moderator or participant.
   */
  isModerator: boolean

  /**
   * Is the video muted for this participant
   */
  isVideoMuted : boolean

  /**
   * Is the audio muted for this participant
   */
  isAudioMuted : boolean

  /**
   * Is the participant sharing the screen.
   */
  isSharing : boolean

  /**
   * Is the participant sharing the screen.
   */
   participantGuid : string
  }

export interface MeetingState {
  videoMute : boolean
  audioMute : boolean
  receivingContent: boolean
  connexionState: MeetingConnectionState
}

export const defaultMeetingState: MeetingState = {
  videoMute:  false,
  audioMute: false,
  receivingContent: false,
  connexionState: MeetingConnectionState.IDLE,
}

export const enum SharingState {
  SCREEN = 'screen_sharing',
  VIDEO = 'video_sharing',
  NONE = 'none'
}

export class PeopleAction {
  people: People
  menuVisible: boolean
  askForRename: boolean
  askForRemove: boolean
  askForCnxDetails: boolean
}

export class MeetingStore {
  audioMute: boolean
  videoMute: boolean
  sharingContent: boolean
  currentVideoId: string
  sharingLocalContent: SharingState
  presenterName: string
  presenterGuid: string
  receivingContent: boolean
  connexionState: MeetingConnectionState.IDLE
  selectedMenuPeople: PeopleAction

  constructor() {
    this.audioMute = false
    this.videoMute = false
    this.sharingContent = false
    this.currentVideoId = ''
    this.sharingLocalContent = SharingState.NONE
    this.presenterName = ''
    this.presenterGuid = ''
    this.receivingContent = false
    this.connexionState = MeetingConnectionState.IDLE
    this.selectedMenuPeople = undefined
  }
}
